import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { dataTableParamsBuilder } from "../../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../../utils/hooks/use-pagination-query";
import { http } from "../../../utils/http";

function fetchTermsList(params) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL("/admin/terms", baseUrl);

  if (params.from) {
    endpointUrl.searchParams.append("from", params.from);
  }
  if (params.to) {
    endpointUrl.searchParams.append("to", params.to);
  }

  if (params.status) {
    endpointUrl.searchParams.append("status", params.status);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useTermsList(params = {}) {
  return usePaginationQuery(
    ["terms", params.from, params.to, params.status],
    (paginationState) => fetchTermsList({ ...params, ...paginationState })
  );
}
async function addterms(formData) {
  const data = await http(`/admin/terms`, {
    data: formData,
  });
  return data;
}

export function useAddterms() {
  const queryClient = useQueryClient();

  return useMutation(addterms, {
    onSuccess: () => {
      queryClient.refetchQueries(["terms"]);
    },
  });
}

export function useUpdateterms() {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const res = await http(`/admin/terms`, {
        data,
      });
      return res;
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(["terms"]);
      },
    }
  );
}

async function deletetermsById(id) {
  const data = await http(`/admin/terms/${id}`, {
    method: "DELETE",
  });

  return data;
}

export function useDeletetermsById() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(deletetermsById, {
    onSuccess: () => {
      queryClient.invalidateQueries(["terms"]);
      setTimeout(() => {
        navigate("/bulletin-board");
      }, 1500);
    },
  });
}

export async function fetchtermsDownload() {
  const { data } = await http(`/admin/terms-download`, {
    responseType: "blob",
  });

  return data;
}

export function useTermsDownload() {
  const { data, ...raResult } = useQuery(["terms-download"], () =>
    fetchtermsDownload()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
